import React ,{Component} from 'react'; 
import { Navigate  } from 'react-router-dom';
import axios from 'axios'; 
import Table from '@mui/material/Table';
import Serverurl from './Apiurl';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow'; 
import { makeStyles } from '@mui/styles'; 
import Paper from '@mui/material/Paper';  
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@mui/material/TablePagination'; 
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import AddBoxRoundedIcon from '@mui/icons-material/AddBoxRounded';
import FormControl from '@mui/material/FormControl';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import pageimg from './images/attendance.png';

const headCells = [

  { id: 'qa_question', numeric: false, label: 'Question' },
  /*{ id: 'qa_optiona', numeric: false, label: 'Option A' },
  { id: 'qa_optionb', numeric: false, label: 'Option B' },
  { id: 'qa_optionc', numeric: false, label: 'Option C' },
  { id: 'qa_optiond', numeric: false, label: 'Option D' },
  { id: 'qa_correctans', numeric: false, label: 'Correct ans' },*/
   { id: 'ct_name', numeric: false, label: 'Category' },
   { id: '',  label: '' },
  ]
  function stableSort(array, cmp) {
	  const stabilizedThis = array.map((el, index) => [el, index]);
	  stabilizedThis.sort((a, b) => {
		const order = cmp(a[0], b[0]);
		if (order !== 0) return order;
		return a[1] - b[1];
	  });
	  return stabilizedThis.map(el => el[0]);
}
function desc(a, b, orderBy) {
	  if (b[orderBy] < a[orderBy]) {
		return -1;
	  }
	  if (b[orderBy] > a[orderBy]) {
		return 1;
	  }
	  return 0;
}
function getSorting(order, orderBy) {
	return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

function EnhancedTableHead(props) {
  const { classes,  order, orderBy,  rowCount, onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={useStyles.visuallyHidden}>
                  {order === 'desc' ? ' ' : ' '}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
 
  onRequestSort: PropTypes.func.isRequired,
 
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
const useToolbarStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  
  
  title: {
    flex: '1 1 100%',
  },
}));

const EnhancedTableToolbar = props => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  };

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};


const useStyles = makeStyles({  
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
 icon: {
   verticalalign:'middle',
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
});


export default class Questions extends Component {
	
    constructor(props) {
    super(props);
   
      this.state = {redirect: false,
      QuestionData:[],qaid:'',page: 0 ,prevpage:0,totaldata:0,rowsPerPage:50,rowsPaging:[],
	 
	  order:'desc' ,orderBy:'',titles:'',syllabus:'',categoryarray:[],category:'',rolelabel:'Select category',searchcustomer:'',examarray:[],exam:'',rolelabel1:'Select exam',
	          
      }
       this.updateDonenewParent = this.updateDonenewParent;
	   
	}
	
	updateDonenewParent = (text) => {this.componentDidMount();  }
	
	Search(){
	this.setState({  
      page: 0,
      rowsPerPage:50,
	  prevpage:0,QuestionData:[]
    });
	
//this.componentDidMount();  
}
	
componentDidUpdate() {
	
  if(this.state.prevpage !== this.state.page) {
    this.setState({   prevpage: this.state.page});
  this.apicall(this.state.page, localStorage.getItem("page"));  
  }
}

	componentWillMount() { 
localStorage.setItem("pageactive",3)
}


	componentDidMount() {
	


	 
		
	
	
	document.title = "MM Coching Center - Batch Management";
	
	if(localStorage.getItem("MMCuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }
	
	
	
	  localStorage.setItem("page",this.state.rowsPerPage)
  this.apicall(this.state.page,this.state.rowsPerPage);
  this.onloadcategorybind();
  this.onloadexambind();
} 


 onloadcategorybind(){

    axios.get(Serverurl+'ajaxcategory.php?action=getall')
	
    
      .then((response) => {    
     
      this.setState({  categoryarray: response.data,  });
      })   
    
      .then(data => {
        let roleFromApi = this.state.categoryarray.map(category => {
                            
          return {value: category.ct_id, display:category.ct_name}
        });
      
		
        this.setState({
          categoryarray: [{value: '', display: 'Select category'}].concat(roleFromApi)
        });
      })


} 
onloadexambind(){

    axios.get(Serverurl+'ajaxexam.php?action=getall')
	
    
      .then((response) => {    
     
      this.setState({  examarray: response.data,  });
      })   
    
      .then(data => {
        let roleFromApi = this.state.examarray.map(exam => {
                            
          return {value: exam.ex_id, display:exam.ex_name}
        });
      
		
        this.setState({
          examarray: [{value: '', display: 'Select exam'}].concat(roleFromApi)
        });
      })


}


handleClickSearch=()=>{   
 
  
  this.apicall(this.state.page,this.state.rowsPerPage); 

	
} 

myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
  this.setState({[nam]: val});
 
}

apicall(page,rowsPerPage){
	 
	 axios.get(Serverurl+'ajaxexam.php?action=qgetall&qa_question='+this.state.titles+'&qa_ct_id='+this.state.category+'&StartIndex='+page+'&PageSize='+rowsPerPage+'&qa_ex_id='+this.state.exam)
     
	
  .then(resp => {  
		
    if(resp.data.length>0){
		
			this.setState({  
			  QuestionData: resp.data,  
			   totaldata:parseInt(resp.data[0].count),
			   

		    });
		
			
			let copy=[50, 100, 150, 200, 250];
			
	  
	  this.setState({rowsPaging:copy});
	 
     }
	 else{
		   this.setState({QuestionData:[],totaldata:0});
	 }
 
    });
}



handleChangePage = (event, newPage) => {
  this.setState({ page: newPage }, () => {
    this.apicall(newPage, this.state.rowsPerPage);
  });
};

handleChangeRowsPerPage = event => {
  const newRows = parseInt(event.target.value, 10);
  this.setState({
    page: 0,
    rowsPerPage: newRows,
  }, () => {
    this.apicall(0, newRows);
  });
};
 
  
  
  handleRequestSort = (event, property) => {
  const isAsc = this.state.orderBy === property && this.state.order === 'asc';
  

  this.setState({   orderBy: property,
    order:isAsc  ? 'desc' : 'asc'
   
  });
};


      quesdelete(qaid){  
	
let r = window.confirm("Do you really want to Delete?");
 if(r == true){ //sign Out logic
 var formData = new FormData();
     formData.append('action','qdelete')
	 formData.append('qa_id',qaid)
	 	   
	formData.append('userid',localStorage.getItem("MMCuserid"))
	
	
	 axios.post(Serverurl+"ajaxexam.php", formData, {
        }).then(res => {
    
             this.setState({  
      prevpage: -1,
    
    });
   
 
    setTimeout(() =>  this.componentDidUpdate() ,500); 
  
    
            });
 }
      }


render() {

if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }


  return (
  

  <React.Fragment>
   
<div className="containermain">
<div className="boxheading">
				  <div className="contntpad">
<h2><img src={pageimg}/>Questions </h2>
</div></div>

   <div className="searchmaster">


  
  <ul>
  
 <li>
 <p ><TextField
            variant="outlined"
            margin="normal"
            fullWidth value={this.state.titles}
           inputProps={{tabIndex: "1",maxLength:150}}
			placeholder="Title"
            name="titles" onChange={this.myChangeHandler}
		
          /></p></li>
		
		
				<li><p><FormControl  className="stadrp">
         
        <Select
         native  fullWidth

		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.rolelabel1, value: this.state.exam}}
          onChange={this.myChangeHandler}
          id="exam"
		   value={this.state.exam}
		  name="exam"
		
		
        >
		{this.state.examarray.map(exam => (
            <option  
            
              value={exam.value}
            >
              {exam.display}
            </option  >
          ))}
		
        </Select></FormControl>
		
				</p>
	
			  </li>
		
		
			<li><p><FormControl  className="stadrp">
         
        <Select
         native  fullWidth
		 
		 
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.rolelabel, value: this.state.category }}
          onChange={this.myChangeHandler}
          id="category"
		   value={this.state.category}
		  name="category"
		
		
        >
		{this.state.categoryarray.map(category => (
            <option  
            
              value={category.value}
            >
              {category.display}
            </option  >
          ))}
		
        </Select></FormControl>
		
				</p>
	
			  </li>
	
	
		
		<li><p >
		<Button variant="contained" onClick={this.handleClickSearch} className="frmPrimarybtn" endIcon={<SearchIcon />}>
        Search
      </Button>&nbsp;
	  <a href="/#/AddQuestion">
  <Button variant="contained" className="frmsecondarybtn" endIcon={<AddIcon />}>New</Button>
</a>
</p></li> 
		

		
		</ul>
		
</div>		

<Paper className={useStyles.root}>


  <TableContainer className={useStyles.container}>  
                <Table stickyHeader aria-label="sticky table">  
<TableHead> 
<TableRow>
                                              
                       
						
                      </TableRow></TableHead>
					  
					   <EnhancedTableHead           
              order={this.state.order}
              orderBy={this.state.orderBy}
              
              onRequestSort={this.handleRequestSort}
              rowCount={this.state.QuestionData.length}
            />
                      <TableBody>
                     {stableSort(this.state.QuestionData, 
			getSorting(this.state.order,
			this.state.orderBy)).map((item,index) => {  
           return (
 <React.Fragment>
 <TableRow key={index} >


<TableCell dangerouslySetInnerHTML={{ __html: item.qa_question }}></TableCell>

{/*<TableCell>{item.qa_question}</TableCell>
	<TableCell>{item.qa_optiona}</TableCell>
<TableCell>{item.qa_optionb}</TableCell>
<TableCell>{item.qa_optionc}</TableCell>
<TableCell>{item.qa_optiond}</TableCell>
			<TableCell>{item.qa_correctans}</TableCell>*/}
<TableCell>{item.ct_name}</TableCell>
<TableCell align="left">
<div className="actionbtns">



<a href={`/#/AddQuestion?qaid=${item.qa_id}`}>
  <Button variant="contained" className="frmPrimarybtn" endIcon={<EditIcon />}>Edit</Button>
</a>



<Button variant="contained" className="admsndisablebtn" onClick={()=>{this.quesdelete(item.qa_id)}} endIcon={<DeleteIcon />}>
  Delete
</Button>

 


 </div>
 
 </TableCell>
 </TableRow>

 </React.Fragment>	
);
					})}
					
					{this.state.totaldata===0 &&(
					
					<TableRow key={0} >
<TableCell align="center" colSpan="4">No Records</TableCell>
					</TableRow>
					) }
					
                      </TableBody>


</Table>
  </TableContainer> 
<TablePagination
  rowsPerPageOptions={this.state.rowsPaging}
  component="div"
  count={this.state.totaldata}
  rowsPerPage={this.state.rowsPerPage}
  page={this.state.page}
  onPageChange={this.handleChangePage}
  onRowsPerPageChange={this.handleChangeRowsPerPage}
/>
  
  </Paper>
    
</div>
 </React.Fragment> 

 
 
  );
}
}

